import { useContext } from 'react';
import Context from './Context';

export default function useDropdown() {
    return useContext(Context);
}
